exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__recipe-card-content___2fUXQ{display:flex;flex-flow:column;justify-content:flex-start;align-items:center}.styles__recipe-card-content___2fUXQ .styles__thumbnail___1aBXy{display:flex;justify-content:center;align-items:center;width:100%}.styles__recipe-card-content___2fUXQ .styles__thumbnail___1aBXy div{width:100%;height:300px;background-size:cover;background-position:50%}.styles__recipe-card-content___2fUXQ .styles__thumbnail___1aBXy div:hover{opacity:.7}", ""]);

// exports
exports.locals = {
	"recipe-card-content": "styles__recipe-card-content___2fUXQ",
	"thumbnail": "styles__thumbnail___1aBXy"
};